<template>
  <div class="promoter-container">
    <div class="filter-card">
      <div class="filter-left">
        <el-input v-model="filterForm.keyword" placeholder="搜索域名 / 网站名称 / 申请人..." class="search-input" clearable
          :prefix-icon="Search" />
      </div>
      <div class="filter-right">
        <div class="filter-item">
          <span class="label">申请状态</span>
          <el-select v-model="filterForm.status" placeholder="全部" class="custom-select" clearable>
            <el-option label="全部" value="" />
            <el-option label="待审核" value="0" />
            <el-option label="已通过" value="1" />
            <el-option label="已拒绝" value="2" />
          </el-select>
        </div>
        <div class="filter-item">
          <span class="label">提交时间</span>
          <el-date-picker v-model="filterForm.dateRange" type="daterange" range-separator="→" start-placeholder="开始日期"
            end-placeholder="结束日期" class="custom-datepicker" value-format="YYYY-MM-DD" />
        </div>
        <el-button class="btn-reset" @click="handleReset">重置</el-button>
        <el-button class="btn-filter" type="primary" :icon="Search" @click="fetchApplyList">查询</el-button>
      </div>
    </div>

    <div class="table-card">
      <el-table :data="tableData" style="width: 100%" class="custom-table"
        :header-cell-style="{ background: 'transparent', color: '#8b949e', borderBottom: '1px solid #1f2937' }"
        :row-style="{ background: 'transparent' }" v-loading="loading">
        <el-table-column label="我的域名" min-width="180">
          <template #default="{ row }">
            <a :href="row.domain" target="_blank" class="domain-link">{{ row.domain }}</a>
          </template>
        </el-table-column>

        <el-table-column label="Logo" width="100">
          <template #default="{ row }">
            <el-image :src="row.logo" class="site-logo" fit="cover" :preview-src-list="[row.navLogo]"
              preview-teleported>
              <template #error>
                <div class="image-slot"><el-icon>
                    <Picture />
                  </el-icon></div>
              </template>
            </el-image>
          </template>
        </el-table-column>

        <el-table-column label="导航Logo" width="140">
          <template #default="{ row }">
            <el-image :src="row.navLogo" class="nav-logo" fit="contain" :preview-src-list="[row.navLogo]"
              preview-teleported>
              <template #error>
                <div class="image-slot"><el-icon>
                    <Picture />
                  </el-icon></div>
              </template>
            </el-image>
          </template>
        </el-table-column>

        <el-table-column label="网站名称" min-width="180">
          <template #default="{ row }">
            <div class="site-info">
              <div class="site-name">{{ row.siteName }}</div>
              <div class="site-category">{{ row.categoryDesc }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="联系二维码 (我的二维码 / 群二维码)" min-width="260">
          <template #default="{ row }">
            <div class="qr-container">
              <div class="qr-item">
                <el-image v-if="row.myQr" :src="row.myQr" :preview-src-list="[row.myQr]" preview-teleported
                  fit="contain" class="qr-img" />
                <span class="qr-tag primary">我的二维码</span>
              </div>
              <div class="qr-item">
                <el-image v-if="row.groupQr" :src="row.groupQr" :preview-src-list="[row.groupQr]" preview-teleported
                  fit="contain" class="qr-img" />
                <span class="qr-tag success">群二维码</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="员工席位" width="130" align="center">
          <template #default="{ row }">
            <div class="seat-cell">
              <strong>{{ row.seatLimit }}</strong>
              <span>个席位</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="370" align="right">
          <template #default="{ row }">
            <template v-if="row.status === 0">
              <el-button class="action-btn btn-pass" :icon="Check" size="small"
                @click="handleAction(row, 'pass')">通过</el-button>
              <el-button class="action-btn btn-reject" :icon="Close" size="small"
                @click="handleAction(row, 'reject')">拒绝</el-button>
            </template>

            <template v-else-if="row.status === 1">
              <el-tag class="custom-status-tag tag-pass" effect="dark" round>已通过</el-tag>
              <el-button class="action-btn btn-edit-domain" :icon="Edit" size="small"
                @click="openSeatDialog(row)">修改席位</el-button>
              <el-button class="action-btn btn-edit-domain" :icon="Edit" size="small"
                @click="openDomainDialog(row)">修改域名</el-button>
            </template>

            <template v-else-if="row.status === 2">
              <el-tag class="custom-status-tag tag-reject" effect="dark" round style="margin-right: 12px;">已拒绝</el-tag>
              <el-button class="action-btn btn-pass" :icon="Check" size="small"
                @click="handleAction(row, 'pass')">重新通过</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- 弹窗 -->
      <el-dialog v-model="auditDialogVisible" title="审核通过配置" width="400px" @close="resetAuditForm">
        <el-form ref="auditFormRef" :model="auditForm" :rules="auditRules" label-width="90px">
          <el-form-item label="代理类型" prop="brandtype">
            <el-select v-model="auditForm.brandtype" placeholder="请选择代理类型" style="width: 100%"
              @change="handleBrandTypeChange">
              <el-option label="一级代理" value="yes" />
              <el-option label="二级代理" value="two" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="auditForm.brandtype === 'two'" label="上级手机号" prop="parent_phone">
            <el-input v-model.trim="auditForm.parent_phone" placeholder="请输入一级代理手机号" maxlength="11" clearable />
          </el-form-item>
          <el-form-item label="初始密码" prop="password">
            <el-input v-model="auditForm.password" placeholder="请输入初始密码" clearable />
          </el-form-item>
          <el-form-item label="分成比例" prop="reward_ratio">
            <el-input v-model="auditForm.reward_ratio" placeholder="例如: 50" clearable>
              <template #append>%</template>
            </el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="auditDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitPassAudit" :loading="submitLoading">确定通过</el-button>
          </span>
        </template>
      </el-dialog>

      <el-dialog v-model="domainDialogVisible" title="修改品牌域名" width="460px" @close="resetDomainForm">
        <el-form ref="domainFormRef" :model="domainForm" :rules="domainRules" label-width="90px">
          <el-form-item label="旧域名">
            <el-input :model-value="currentDomainRow?.domain || ''" disabled />
          </el-form-item>
          <el-form-item label="新域名" prop="domain">
            <el-input v-model="domainForm.domain" placeholder="例如：example.com" clearable />
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="domainDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitDomainChange" :loading="domainSubmitLoading">确认修改</el-button>
          </span>
        </template>
      </el-dialog>

      <el-dialog v-model="seatDialogVisible" title="修改员工席位" width="430px" @close="resetSeatForm">
        <el-form label-width="100px">
          <el-form-item label="品牌域名">
            <el-input :model-value="currentSeatRow?.domain || ''" disabled />
          </el-form-item>
          <el-form-item label="席位上限">
            <el-input-number v-model="seatForm.limit" :min="0" :max="100000" :step="1" step-strictly
              controls-position="right" style="width: 100%" />
            <div class="seat-tip">限制该品牌主账号可添加的员工数量，后续可以随时调整。</div>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="seatDialogVisible = false">取消</el-button>
            <el-button type="primary" :loading="seatSubmitLoading" @click="submitSeatChange">保存席位</el-button>
          </span>
        </template>
      </el-dialog>

      <div class="pagination-container">
        <span class="total-text">共 {{ total }} 条申请合作</span>
        <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
          :background="true" layout="sizes, prev, pager, next" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" class="custom-pagination" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { Search, Filter, Picture, Check, Close, Edit } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import axios from "axios";
import { API_URL } from "@/util/urls";

// 状态管理 (局部化)
const loading = ref(false);
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(128);
const tableData = ref([]);
const filterForm = reactive({
  keyword: "",
  status: "1", // 默认显示已通过
  category: "",
  dateRange: []
});

// 新增所需变量
const auditDialogVisible = ref(false);
const submitLoading = ref(false);
const auditFormRef = ref(null);
const currentAuditRow = ref(null); // 记录当前正在审核的行数据
const domainDialogVisible = ref(false);
const domainSubmitLoading = ref(false);
const domainFormRef = ref(null);
const currentDomainRow = ref(null);
const seatDialogVisible = ref(false);
const seatSubmitLoading = ref(false);
const currentSeatRow = ref(null);

// 表单数据绑定
const auditForm = reactive({
  password: "",
  reward_ratio: "",
  brandtype: "yes",
  parent_phone: ""
});

const domainForm = reactive({
  domain: ""
});

const seatForm = reactive({
  limit: 0
});

const normalizeDomainInput = (value = "") => {
  const raw = String(value);
  const trimmed = raw.trim();
  if (!trimmed) return "";
  if (/\s/.test(raw)) return trimmed;
  return trimmed.replace(/\/+$/, "").toLowerCase();
};

const validateDomain = (rule, value, callback) => {
  const raw = String(value || "");
  const trimmed = raw.trim();
  if (!trimmed) return callback(new Error("请输入新域名"));
  if (raw !== trimmed || /\s/.test(raw)) return callback(new Error("域名不能包含空格、换行或制表符"));
  if (/^https?:\/\//i.test(trimmed)) return callback(new Error("域名不需要填写 http:// 或 https:// 前缀"));
  if (trimmed.includes("/")) return callback(new Error("只填写域名，不要填写路径"));

  const normalized = normalizeDomainInput(trimmed);
  const domainText = normalized;
  const domainReg = /^(?!-)([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}(:\d{1,5})?$/;
  if (!domainReg.test(domainText)) return callback(new Error("请输入正确的域名，例如 example.com"));
  callback();
};

const validateParentPhone = (rule, value, callback) => {
  if (auditForm.brandtype !== "two") return callback();

  const phone = String(value || "").trim();
  if (!phone) return callback(new Error("请输入一级代理手机号"));
  if (!/^1[3-9]\d{9}$/.test(phone)) return callback(new Error("请输入正确的一级代理手机号"));
  callback();
};

// 表单校验规则
const auditRules = {
  brandtype: [{ required: true, message: "请选择代理类型", trigger: "change" }],
  parent_phone: [{ validator: validateParentPhone, trigger: "blur" }],
  password: [{ required: true, message: "请输入初始密码", trigger: "blur" }],
  reward_ratio: [{ required: true, message: "请输入分成比例", trigger: "blur" }]
};

const domainRules = {
  domain: [{ validator: validateDomain, trigger: "blur" }]
};

// 关闭弹窗时重置表单
const resetAuditForm = () => {
  auditFormRef.value?.resetFields();
  Object.assign(auditForm, {
    password: "",
    reward_ratio: "",
    brandtype: "yes",
    parent_phone: ""
  });
  currentAuditRow.value = null;
};

const handleBrandTypeChange = (brandtype) => {
  if (brandtype !== "two") auditForm.parent_phone = "";
  auditFormRef.value?.clearValidate("parent_phone");
};

const resetDomainForm = () => {
  currentDomainRow.value = null;
  domainForm.domain = "";
  domainFormRef.value?.clearValidate();
};

const openDomainDialog = (row) => {
  currentDomainRow.value = row;
  domainForm.domain = row.domain || "";
  domainDialogVisible.value = true;
};

const resetSeatForm = () => {
  currentSeatRow.value = null;
  seatForm.limit = 0;
};

const openSeatDialog = (row) => {
  currentSeatRow.value = row;
  seatForm.limit = Number(row.seatLimit || 0);
  seatDialogVisible.value = true;
};

const submitSeatChange = async () => {
  if (!currentSeatRow.value) return;
  const seatLimit = Number(seatForm.limit);
  if (!Number.isSafeInteger(seatLimit) || seatLimit < 0) {
    ElMessage.warning("席位数量必须是大于或等于0的整数");
    return;
  }

  seatSubmitLoading.value = true;
  try {
    const response = await axios.post("/admin/updateBrandSeatLimit", {
      id: currentSeatRow.value.id,
      seatLimit
    });
    if (response.data.msg !== "success") {
      throw new Error(response.data.error || "席位修改失败");
    }
    ElMessage.success("员工席位已更新");
    seatDialogVisible.value = false;
    fetchApplyList();
  } catch (error) {
    console.error("修改员工席位失败:", error);
    ElMessage.error(error.response?.data?.error || error.message || "席位修改失败");
  } finally {
    seatSubmitLoading.value = false;
  }
};

const submitDomainChange = () => {
  domainFormRef.value.validate(async (valid) => {
    if (!valid || !currentDomainRow.value) return;

    const oldDomain = normalizeDomainInput(currentDomainRow.value.domain);
    const newDomain = normalizeDomainInput(domainForm.domain);
    if (oldDomain === newDomain) {
      ElMessage.warning("新旧域名一致，无需修改");
      return;
    }

    try {
      await ElMessageBox.confirm(
        `确定将品牌域名从 [${oldDomain}] 修改为 [${newDomain}] 吗？相关用户、消费记录和分成记录会同步迁移。`,
        "修改域名确认",
        {
          confirmButtonText: "确认修改",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "custom-message-box"
        }
      );

      domainSubmitLoading.value = true;
      const response = await axios.post(`/admin/updateBrandDomain`, {
        id: currentDomainRow.value.id,
        oldDomain,
        newDomain
      });

      if (response.data.msg === "success") {
        ElMessage.success("域名修改成功");
        domainDialogVisible.value = false;
        fetchApplyList();
      } else {
        ElMessage.error(response.data.error || "域名修改失败");
      }
    } catch (error) {
      if (error !== "cancel" && error !== "close") {
        console.error("域名修改失败:", error);
        ElMessage.error(error.response?.data?.error || error.message || "系统错误，域名修改失败");
      }
    } finally {
      domainSubmitLoading.value = false;
    }
  });
};

// 修改原有的 handleAction：拆分“通过”和“拒绝”的逻辑
const handleAction = (row, type) => {
  if (type === 'pass') {
    // 如果是通过，记录当前行并打开弹窗
    Object.assign(auditForm, {
      password: "",
      reward_ratio: "",
      brandtype: "yes",
      parent_phone: ""
    });
    auditFormRef.value?.clearValidate();
    currentAuditRow.value = row;
    auditDialogVisible.value = true;
  } else {
    // 如果是拒绝，保留原有的直接确认逻辑
    ElMessageBox.confirm(
      `确定要拒绝该域名 [${row.domain}] 的合作申请吗？`,
      "操作提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "custom-message-box"
      }
    ).then(async () => {
      try {
        const response = await axios.post(`/admin/auditBrand`, {
          id: row.id,
          status: 2, // 拒绝状态码
          reward_ratio: 0
        });

        if (response.data.msg === "success") {
          ElMessage.success("已成功拒绝该申请");
          fetchApplyList();
        } else {
          ElMessage.error(response.data.error || "操作失败");
        }
      } catch (error) {
        console.error("审核拒绝失败:", error);
        ElMessage.error("系统错误，操作未完成");
      }
    }).catch(() => { });
  }
};

// 新增：处理弹窗提交（审核通过）的逻辑
const submitPassAudit = () => {
  auditFormRef.value.validate(async (valid) => {
    if (!valid) return;

    submitLoading.value = true;
    try {
      const response = await axios.post(`/admin/auditBrand`, {
        id: currentAuditRow.value.id,
        status: 1, // 通过状态码
        password: auditForm.password,
        reward_ratio: auditForm.reward_ratio,
        brandtype: auditForm.brandtype,
        parent_phone: auditForm.brandtype === "two" ? auditForm.parent_phone.trim() : null
      });

      if (response.data.msg === "success") {
        ElMessage.success(`已成功通过 [${currentAuditRow.value.domain}] 的申请`);
        auditDialogVisible.value = false;
        fetchApplyList();
      } else {
        ElMessage.error(response.data.error || "操作失败");
      }
    } catch (error) {
      console.error("审核通过失败:", error);
      ElMessage.error(error.response?.data?.error || error.message || "系统错误，操作未完成");
    } finally {
      submitLoading.value = false;
    }
  });
};

// 重置筛选
const handleReset = () => {
  filterForm.keyword = "";
  filterForm.status = "0"; // 重置时也回到待审核状态
  filterForm.category = "";
  filterForm.dateRange = [];
  currentPage.value = 1;
  fetchApplyList();
};

// 核心查询逻辑 (根据你的 Axios 结构改写)
const fetchApplyList = async () => {
  loading.value = true;
  try {
    // 1. 准备请求参数
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value,
      keyword: filterForm.keyword.trim(),
      // 只有当 status 不为空字符串时，才传递数值
      status: filterForm.status !== "" ? Number(filterForm.status) : undefined,
      startDate: filterForm.dateRange?.[0] || '',
      endDate: filterForm.dateRange?.[1] || ''
    };
    // 2. 调用真实接口
    const response = await axios.get(`/admin/fetchApplyList`, { params });
    console.log("获取结果", response.data)
    const { msg, data } = response.data

    if (msg === "success") {
      const { list, total: totalCount } = data;
      const toop = `${API_URL}/getfile/`
      // 3. 处理图片路径 (如果后端返回的是相对路径，需要拼接域名) 
      tableData.value = list.map(item => ({
        ...item,
        seatLimit: item.team_seat_limit === null || item.team_seat_limit === undefined
          ? (item.brandtype === 'two' ? 5 : 10)
          : Number(item.team_seat_limit),
        // 这里根据你的静态资源配置拼接完整 URL
        logo: `${toop}${item.logo}`,
        navLogo: `${toop}${item.navLogo}`,
        myQr: `${toop}${item.myQr}`,
        groupQr: `${toop}${item.groupQr}`,
        // 映射分类描述 (如果数据库里没存描述，可以在前端根据业务逻辑写死)
        categoryDesc: item.category || '默认分类'
      }));

      total.value = totalCount;
    } else {
      ElMessage.error("获取列表失败: " + response.data.error);
    }
  } catch (error) {
    console.error("获取申请列表失败:", error);
    ElMessage.error("网络异常，请稍后重试");
  } finally {
    loading.value = false;
  }
};

// 审核操作 (通过/拒绝)
const handleActionX = (row, type) => {
  const actionName = type === 'pass' ? '通过' : '拒绝';
  // 映射状态码：1 表示通过，2 表示拒绝
  const statusCode = type === 'pass' ? 1 : 2;

  ElMessageBox.confirm(
    `确定要 ${actionName} 该域名 [${row.domain}] 的合作申请吗？`,
    "操作提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: type === 'pass' ? 'success' : 'warning',
      // 暗黑模式下确认框的样式优化（可选）
      customClass: 'custom-message-box'
    }
  ).then(async () => {
    try {
      // 1. 发送状态更新请求
      const response = await axios.post(`/admin/auditBrand`, {
        id: row.id,
        status: statusCode,

      });

      if (response.data.msg === "success") {
        ElMessage({
          type: 'success',
          message: `已成功${actionName}该申请`,
          duration: 2000
        });
        // 2. 刷新列表
        fetchApplyList();
      } else {
        ElMessage.error(response.data.error || "操作失败");
      }
    } catch (error) {
      console.error(`审核[${actionName}]失败:`, error);
      ElMessage.error("系统错误，操作未完成");
    }
  }).catch(() => {
    // 点击取消不需要额外处理
  });
};

// 分页事件
const handleSizeChange = (val) => {
  pageSize.value = val;
  currentPage.value = 1;
  fetchApplyList();
};

const handleCurrentChange = (val) => {
  currentPage.value = val;
  fetchApplyList();
};

// 模拟数据生成器 (完美匹配你的截图内容)
const generateMockData = () => {
  return {
    total: 128,
    list: [
      { id: 1, domain: 'https://starlink.com', logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=starlink&backgroundColor=0d1117', navLogo: 'https://api.dicebear.com/7.x/shapes/svg?seed=starlink2&backgroundColor=000000', siteName: '星链导航', categoryDesc: '科技 / 导航', myQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr1', groupQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr2' },
      { id: 2, domain: 'https://galaxyhub.net', logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=galaxy&backgroundColor=0d1117', navLogo: 'https://api.dicebear.com/7.x/shapes/svg?seed=galaxy2&backgroundColor=000000', siteName: 'GalaxyHub', categoryDesc: '资源 / 工具', myQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr3', groupQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr4' },
      { id: 3, domain: 'https://orbitnav.io', logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=orbit&backgroundColor=0d1117', navLogo: 'https://api.dicebear.com/7.x/shapes/svg?seed=orbit2&backgroundColor=000000', siteName: 'OrbitNav 导航', categoryDesc: '导航 / 聚合', myQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr5', groupQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr6' },
      { id: 4, domain: 'https://nebulaapp.com', logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=nebula&backgroundColor=0d1117', navLogo: 'https://api.dicebear.com/7.x/shapes/svg?seed=nebula2&backgroundColor=000000', siteName: 'Nebula 应用市场', categoryDesc: '应用 / 市场', myQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr7', groupQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr8' },
      { id: 5, domain: 'https://universetools.pro', logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=universe&backgroundColor=0d1117', navLogo: 'https://api.dicebear.com/7.x/shapes/svg?seed=universe2&backgroundColor=000000', siteName: 'Universe Tools', categoryDesc: '工具 / 效率', myQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr9', groupQr: 'https://api.dicebear.com/7.x/identicon/svg?seed=qr10' }
    ]
  };
};

onMounted(() => {
  fetchApplyList();
});
</script>

<style scoped>
/* 全局容器变量 & 基础样式 */
.promoter-container {
  padding: 20px;
  background-color: #0b0e14;
  /* 极暗黑背景 */
  min-height: 100vh;
  color: #e5e7eb;
  font-family: system-ui, -apple-system, sans-serif;
}

/* 顶部筛选卡片 */
.filter-card {
  background: #11151f;
  border: 1px solid #1f2937;
  border-radius: 12px;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-left .search-input {
  width: 280px;
}

.filter-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;

  /* 给下拉选择框设置固定宽度，防止被 flex 容器挤压 */
  .custom-select {
    width: 140px;
    /* 宽度可以根据你的视觉需求微调，比如 120px - 140px */
  }

  /* 如果你的日期选择器也有类似问题，可以顺便给日期选择器加个宽度 */
  .custom-datepicker {
    width: 260px;
  }
}

.filter-item .label {
  font-size: 13px;
  color: #8b949e;
  white-space: nowrap;
}

/* 表格卡片区域 */
.table-card {
  background: #11151f;
  border: 1px solid #1f2937;
  border-radius: 12px;
  padding: 20px;
}

/* 覆盖 Element Plus 默认样式适配暗黑风 */
:deep(.el-input__wrapper),
:deep(.el-select__wrapper) {
  background-color: #0d1117 !important;
  box-shadow: 0 0 0 1px #1f2937 inset !important;
}

:deep(.el-input__inner) {
  color: #e5e7eb !important;
}

:deep(.el-table) {
  background-color: transparent !important;
  --el-table-border-color: #1f2937;
  --el-table-row-hover-bg-color: #161b22;
}

:deep(.el-table tr),
:deep(.el-table th.el-table__cell) {
  background-color: transparent !important;
}

:deep(.el-table td.el-table__cell) {
  border-bottom: 1px solid #1f2937;
}

:deep(.el-table::before) {
  display: none;
  /* 去除底部多余边框 */
}

/* 表格内部元素样式 */
.domain-link {
  color: #3b82f6;
  text-decoration: none;
  font-size: 14px;
}

.domain-link:hover {
  text-decoration: underline;
}

.btn-edit-domain {
  margin-left: 10px;
  color: #60a5fa;
  border: 1px solid rgba(96, 165, 250, 0.35);
  background: rgba(37, 99, 235, 0.12);
}

.btn-edit-domain:hover {
  color: #dbeafe;
  border-color: rgba(96, 165, 250, 0.7);
  background: rgba(37, 99, 235, 0.24);
}

.site-logo {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background-color: #000;
  border: 1px solid #1f2937;
}

.nav-logo {
  width: 80px;
  height: 44px;
  border-radius: 8px;
  background-color: #000;
  border: 1px solid #1f2937;
}

.site-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.site-name {
  font-size: 14px;
  color: #e5e7eb;
  font-weight: 500;
}

.site-category {
  font-size: 12px;
  color: #8b949e;
  background: rgba(59, 130, 246, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
  width: fit-content;
}

.qr-container {
  display: flex;
  gap: 16px;
  align-items: center;
}

.qr-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #0d1117;
  padding: 4px;
  border-radius: 6px;
  border: 1px solid #1f2937;
}

.qr-img {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: #fff;
}

.qr-tag {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

.qr-tag.primary {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
}

.qr-tag.success {
  background: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}

.seat-cell {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  padding: 5px 10px;
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 6px;
  color: #91a4bd;
  background: rgba(59, 130, 246, 0.08);
}

.seat-cell strong {
  color: #60a5fa;
  font-size: 16px;
}

.seat-tip {
  margin-top: 6px;
  color: #8494aa;
  font-size: 12px;
  line-height: 1.5;
}

/* 关键按钮样式 - 黑客绿与警告红发光质感 */
.action-btn {
  background-color: transparent !important;
  border-radius: 6px;
  padding: 6px 16px;
  transition: all 0.2s ease;
}

.btn-pass {
  border: 1px solid #22c55e !important;
  color: #22c55e !important;
}

.btn-pass:hover {
  background-color: rgba(34, 197, 94, 0.1) !important;
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.2);
}

.btn-reject {
  border: 1px solid #ef4444 !important;
  color: #ef4444 !important;
}

.btn-reject:hover {
  background-color: rgba(239, 68, 68, 0.1) !important;
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.2);
}

.btn-reset {
  background: #1f2937 !important;
  border: 1px solid #374151 !important;
  color: #e5e7eb !important;
}

.btn-filter {
  background: transparent !important;
  border: 1px solid #3b82f6 !important;
  color: #3b82f6 !important;
}

/* 底部底栏及分页 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
}

.total-text {
  color: #8b949e;
  font-size: 14px;
}

/* 分页器暗黑适配 */
:deep(.el-pagination.is-background .el-pager li:not(.is-active)) {
  background-color: #0d1117;
  color: #8b949e;
  border: 1px solid #1f2937;
}

:deep(.el-pagination.is-background .btn-next),
:deep(.el-pagination.is-background .btn-prev) {
  background-color: #0d1117;
  color: #8b949e;
  border: 1px solid #1f2937;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
  background-color: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  border: 1px solid #3b82f6;
}
</style>
